import { Component, ElementRef, Input, ViewChild, OnInit } from '@angular/core';

import { DataTablesService } from '../../../../core';
import { DecimalFormatPipe } from '../../../../shared';
import { CurvaAbcVenda } from '../curva-abc-venda';
import { CurvaAbcVendaEntity } from '../curva-abc-venda-entity';
import { CurvaAbcVendaEntityOrderBy } from '../orderby';
import { CurvaAbcVendaPerspectiva } from '../perspectiva';

@Component({
    selector: 'sgt-curva-abc-venda-table',
    templateUrl: './curva-abc-venda-table.component.html',
    styleUrls: ['./curva-abc-venda-table.component.less']
})
export class CurvaAbcVendaTableComponent implements OnInit {
    @Input() perspectiva: CurvaAbcVendaPerspectiva;
    @Input() curvaAbcVenda: CurvaAbcVenda;
    @Input() isShowCodigoIntegracaoErp = false;

    private dataTable: any;
    @ViewChild('tableElement', {static: true}) tableElement: ElementRef;
    private columns: any[] = [
        {
            data: 'codigoIntegracaoErp',
            className: 'col-codigo-integracao',
            serverOrderByColumn: CurvaAbcVendaEntityOrderBy.CodigoIntegracaoErp,
        },
        {
            data: 'nome',
            className: 'col-nome',
            serverOrderByColumn: CurvaAbcVendaEntityOrderBy.Nome,
        },
        {
            data: 'quantidade',
            className: 'col-quantidade text-right',
            serverOrderByColumn: CurvaAbcVendaEntityOrderBy.Quantidade,
            render: (data: number) => this.decimalFormatPipe.transform(data, 1, 2, 2),
        },
        {
            data: null,
            className: 'col-quantidade-convertida text-right',
            serverOrderByColumn: CurvaAbcVendaEntityOrderBy.QuantidadeConvertida,
            render: (data: CurvaAbcVendaEntity) => this.decimalFormatPipe.transform(data?.quantidadeConvertida, 1, 2, 2),
            createdCell: (td: any, cellData: any, data: CurvaAbcVendaEntity) => {
                if (data && data.fatorConversao) {
                    td.title = `Fator conversão = ${this.decimalFormatPipe.transform(data.fatorConversao, 1, 0, 0)} * ${this.decimalFormatPipe.transform(data.quantidade, 1, 2, 2)}`;
                }
            }
        },
        {
            data: 'peso',
            className: 'col-peso text-right',
            serverOrderByColumn: CurvaAbcVendaEntityOrderBy.Peso,
            render: (data: number) => this.decimalFormatPipe.transform(data, 1, 2, 2),
        },
        {
            data: 'valorTotal',
            className: 'col-valor text-right',
            serverOrderByColumn: CurvaAbcVendaEntityOrderBy.ValorTotal,
            render: (data: number) => this.decimalFormatPipe.transform(data, 1, 2, 2),
        },
        {
            data: 'precoMedio',
            className: 'col-preco-medio text-right',
            serverOrderByColumn: CurvaAbcVendaEntityOrderBy.PrecoMedio,
            render: (data: number) => this.decimalFormatPipe.transform(data, 1, 2, 2),
        },
        {
            data: 'precoMedioConvertido',
            className: 'col-preco-medio-convertido text-right',
            serverOrderByColumn: CurvaAbcVendaEntityOrderBy.PrecoMedioConvertido,
            render: (data: number) => this.decimalFormatPipe.transform(data, 1, 2, 2),
        },
        {
            data: 'percParticipacao',
            className: 'col-perc-participacao text-right',
            serverOrderByColumn: CurvaAbcVendaEntityOrderBy.PercParticipacao,
            render: (data: number) => `${this.decimalFormatPipe.transform(data, 1, 2, 2)}%`,
        },
        {
            data: 'quantidadeMedia',
            className: 'col-quantidade-media text-right',
            serverOrderByColumn: CurvaAbcVendaEntityOrderBy.QuantidadeMedia,
            render: (data: number) => this.decimalFormatPipe.transform(data, 1, 2, 2),
        },
        {
            data: 'quantidadeConvertidaMedia',
            className: 'col-quantidade-convertida-media text-right',
            serverOrderByColumn: CurvaAbcVendaEntityOrderBy.QuantidadeConvertidaMedia,
            render: (data: number) => this.decimalFormatPipe.transform(data, 1, 2, 2),
        },
        {
            data: 'pesoMedio',
            className: 'col-peso-medio text-right',
            serverOrderByColumn: CurvaAbcVendaEntityOrderBy.PesoMedio,
            render: (data: number) => this.decimalFormatPipe.transform(data, 1, 2, 2),
        },
        {
            data: 'valorMedio',
            className: 'col-valor-medio text-right',
            serverOrderByColumn: CurvaAbcVendaEntityOrderBy.ValorMedio,
            render: (data: number) => this.decimalFormatPipe.transform(data, 1, 2, 2),
        },
    ];


    constructor(private dataTablesService: DataTablesService,
                private decimalFormatPipe: DecimalFormatPipe) { }

    ngOnInit() {
        this.createTable();
    }

    private createTable() {
        const columnDefs: any[] = [];
        if (!this.isShowCodigoIntegracaoErp) {
            columnDefs.push({visible: false, targets: [0]});
        } else {
            columnDefs.push({orderable: true, targets: [0]});
        }

        this.dataTablesService.showTable(jQuery(this.tableElement?.nativeElement), this.dataTable, {
            order: [[2, 'desc']], // quantidade desc
            data: [],
            columns: this.columns,
            columnDefs,
            paging: false,
            searching: false,
            info: false,
            scrollX:        true,
        }).then(dataTable => this.dataTable = dataTable);
    }

    /** Atualiza a tabela */
    refresh() {
        this.dataTable?.clear();
        this.dataTable?.rows?.add(this.curvaAbcVenda?.entities).draw();
    }

    /** Obtem a coluna de ordenação da table */
    getOrderBy(): number {
        if (!this.dataTable) {
            return null;
        }

        try {
            const order = this.dataTable.order();
            const orderColumn =  this.columns[order[0][0]];
            return orderColumn?.serverOrderByColumn;
        } catch (error) {
            return 0;
        }
    }

    /** Obtem a direção da coluna de ordenação da table */
    getOrderByDir(): string {
        if (!this.dataTable) {
            return null;
        }

        try {
            const order = this.dataTable.order();
            return order ? order[0][1] : null;
        } catch (error) {
            return 'asc';
        }
    }
}
